export var FunctionButtonKind;
(function (FunctionButtonKind) {
    FunctionButtonKind["TOGGLE"] = "toggle";
    FunctionButtonKind["PRESS"] = "press";
})(FunctionButtonKind || (FunctionButtonKind = {}));
